<template>
    <div :id="`div-gpt-ad-1556913755435-${ this.adId }`" class="div-gpt-ad div-gpt-ad-flex" :style="divStyle">
    </div>
 </template>

 <script>
export default {
    name: 'google-ad',
    props: {
        adId: {
            type: String,
            required: true,
            default: '0'
        }
    },
    mounted() {
        this.initializeForm()
    },
    computed: {
        divStyle() {
            if (this.adId == '0' || this.adId == '5') {
                return "min-height:90px;"
            } else {
                return "height:250px; width:300px; margin:auto;"
            }
        },
    },
    methods: {
        initializeForm() {
            const script = document.createElement("script")
            script.innerHTML = `googletag.cmd.push(function() { googletag.display('div-gpt-ad-1556913755435-${ this.adId }'); });`
            document.body.appendChild(script);
        }
    }
}

</script>
 